var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMenuDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.642787,
    x2: 16,
    y2: 0.642787,
    stroke: "white",
    strokeWidth: 1.28571
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 5.64279,
    x2: 16,
    y2: 5.64279,
    stroke: "white",
    strokeWidth: 1.28571
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 10.6428,
    x2: 16,
    y2: 10.6428,
    stroke: "white",
    strokeWidth: 1.28571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuDrawer);
export default __webpack_public_path__ + "static/media/nav_menu_drawer.7a2cb7cc38f047fdccbe18220f666d48.svg";
export { ForwardRef as ReactComponent };